module.exports = require('@nerdwallet/global-markup-options');
